import React from 'react';

import styled from 'styled-components';

import { isCommunityCCRC } from 'components/Community/utils';
import { useCommunityViewContext } from 'components/View/CommunityViewContext';

import { PRICING_COMPARISON_COLUMN_WIDTH } from './constants';
import { formatRoomTypeHeader } from './utils';

const HeaderTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
  border: 0;
  min-width: 700px;
`;

const HeaderRow = styled.tr`
  height: 40px;
`;

const HeaderCell = styled.th`
  text-align: left;
  font-size: 12px;
  font-family: var(--font-bold);
  color: var(--text-tertiary);
  padding: 0 16px 6px;
  vertical-align: middle;
  height: 40px;
`;

type Props = {
  roomTypes: { id: number; name: string }[];
  columnCount: number;
  minTableWidth: number;
};

export const PricingComparisonTableHeader = ({ roomTypes, columnCount, minTableWidth }: Props) => {
  const { community } = useCommunityViewContext();
  const isCCRC = isCommunityCCRC(community?.rental_types ?? []);

  return (
    <HeaderTable style={{ minWidth: `${minTableWidth}px` }} data-testid="pc-widget-header-table">
      <colgroup>
        {Array.from({ length: columnCount }).map((_, index) => (
          <col
            key={`header-col-${index}`}
            style={{ width: `${PRICING_COMPARISON_COLUMN_WIDTH + (index === 0 ? 30 : 0)}px` }}
          />
        ))}
      </colgroup>
      <thead>
        <HeaderRow data-testid="pc-widget-header-row">
          <HeaderCell data-testid="pc-widget-header-cell-care-type">CARE TYPE</HeaderCell>
          {roomTypes.map((roomType) => (
            <HeaderCell
              key={`room-header-${roomType.id}`}
              data-testid={`pc-widget-header-cell-room-type-${roomType.id}`}
            >
              {formatRoomTypeHeader(roomType.name)}
            </HeaderCell>
          ))}
          {isCCRC ? (
            <HeaderCell data-testid="pc-widget-header-cell-entrance-fee">ENTRANCE FEE</HeaderCell>
          ) : (
            <HeaderCell data-testid="pc-widget-header-cell-community-fee">COMM. FEE</HeaderCell>
          )}
          <HeaderCell data-testid="pc-widget-header-cell-fee-type">FEE TYPE</HeaderCell>
          <HeaderCell data-testid="pc-widget-header-cell-care-fee">CARE FEE</HeaderCell>
          {isCCRC && <HeaderCell data-testid="pc-widget-header-cell-contract-type">CONTRACT TYPE</HeaderCell>}
        </HeaderRow>
      </thead>
    </HeaderTable>
  );
};

export default PricingComparisonTableHeader;
